import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import Notification from "../../api/repositories/notification";
import {handleApiError} from "../../helpers/handleApiError";
import {formatToLocaleTime} from "../../shared/utils/formatToLocaleTime";
import {notificationText} from "../../shared/constants";

const initialState = {
  isLoading: false,
  notification: [],
  qrGenerationCompleted: false,
  previousNotificationCount: 0
};

export const getNotifications = createAsyncThunk(
    "notification/getNotifications",
    async (_, { dispatch, getState }) => {
      try {
        const response = await Notification.get_notifications();
        
        if (response.data?.Event) {
          const notifications = response.data.Event;
          const state = getState();
          const previousCount = state.notification.previousNotificationCount;
          
          // Проверяем, увеличилось ли число уведомлений
          if (notifications.length > previousCount) {
            // Проверяем, есть ли среди новых уведомлений о генерации QR кодов
            const hasQrReadyNotification = notifications.some(notif => notif.data === 4);
            
            if (hasQrReadyNotification) {
              // Устанавливаем флаг для обновления QR кодов
              dispatch(setQrGenerationCompleted(true));
            }
          }
          
          // Обновляем счетчик уведомлений
          dispatch(setNotificationCount(notifications.length));
        }
        
        return response.data;
      } catch (error) {
        // handleApiError(error)
      }
    },
);

export const checkNotifications = createAsyncThunk(
    "notification/checkNotifications",
    async () => {
      try {
        const response = await Notification.check_notifications();
        return response.data;
      } catch (error) {
        // handleApiError(error)
      }
    },
);

export const deleteAllNotifications = createAsyncThunk(
    "notification/deleteAllNotifications",
    async ({ dispatch }) => {
      try {
        const response = await Notification.delete_all_notifications();

        dispatch(getNotifications())

        return response.data;
      } catch (error) {
        handleApiError(error)
      }
    },
);

export const deleteNotification = createAsyncThunk(
    "notification/deleteNotification",
    async (payload, { dispatch }) => {
      try {
        const response = await Notification.delete_notification(payload);

        dispatch(getNotifications())

        return response.data;
      } catch (error) {
        handleApiError(error)
      }
    },
);

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setQrGenerationCompleted: (state, action) => {
      state.qrGenerationCompleted = action.payload;
    },
    setNotificationCount: (state, action) => {
      state.previousNotificationCount = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
        .addCase(getNotifications.pending, (state) => {
          state.isLoading = true
        })
        .addCase(getNotifications.fulfilled, (state, { payload }) => {
          state.isLoading = false;
          if (payload?.Event) {
            const newNotifications = payload.Event.map((item, index) => ({
              date: formatToLocaleTime(item.date),
              text: notificationText[item.data] || "Unknown notification",
              isRead: item.read,
              type: item.type,
              id: index,
            }));

            // Сравниваем массивы, чтобы обновлять только при реальном изменении
            if (JSON.stringify(newNotifications) !== JSON.stringify(state.notification)) {
              state.notification = newNotifications;
            }
          }
        });
    builder
        .addCase(checkNotifications.pending, (state) => {
          state.isLoading = true;
        })
        .addCase(checkNotifications.fulfilled, (state) => {
          state.isLoading = false
        });
    builder
        .addCase(deleteAllNotifications.pending, (state) => {
          state.isLoading = true;
        })
        .addCase(deleteAllNotifications.fulfilled, (state) => {
          state.isLoading = false
        });
    builder
        .addCase(deleteNotification.pending, (state) => {
          state.isLoading = true;
        })
        .addCase(deleteNotification.fulfilled, (state) => {
          state.isLoading = false
        });
  },
});

export const { setQrGenerationCompleted, setNotificationCount } = notificationSlice.actions;
export default notificationSlice.reducer;